import 'core-js/modules/es6.reflect.construct';
import _classCallCheck from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _inherits from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
import _possibleConstructorReturn from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module font/fontcolor/fontcolorui
 */
import ColorUI from '../ui/colorui';
import { FONT_COLOR } from '../utils';
import fontColorIcon from '../../theme/icons/font-color.svg';
/**
 * The font color UI plugin. It introduces the `'fontColor'` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */
var FontColorUI = /*#__PURE__*/
function (_ColorUI) {
    _inherits(FontColorUI, _ColorUI);
    var _super = _createSuper(FontColorUI);
    /**
   * @inheritDoc
   */
    function FontColorUI(editor) {
        _classCallCheck(this, FontColorUI);
        var t = editor.locale.t;
        return _super.call(this, editor, {
            commandName: FONT_COLOR,
            componentName: FONT_COLOR,
            icon: fontColorIcon,
            dropdownLabel: t('Font Color')
        });
    }
    /**
   * @inheritDoc
   */
    _createClass(FontColorUI, null, [{
            key: 'pluginName',
            get: function get() {
                return 'FontColorUI';
            }
        }]);
    return FontColorUI;
}(ColorUI);
export {
    FontColorUI as default
};